import { render } from "./Delivery.vue?vue&type=template&id=71943ece&scoped=true"
import script from "./Delivery.vue?vue&type=script&lang=js"
export * from "./Delivery.vue?vue&type=script&lang=js"

import "./Delivery.vue?vue&type=style&index=0&id=71943ece&scoped=true&lang=scss"

import exportComponent from "D:\\web\\OpenServer\\domains\\lembergflowers\\lembergflowers\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71943ece"]])

export default __exports__